import { Component, OnInit, PLATFORM_ID, Inject, Renderer2, ElementRef, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';
import { isPlatformServer, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { LoadScriptService } from 'src/app/_services/load-script.service';
import Glide from '@glidejs/glide';
import { NavigationService } from 'src/app/_services/navigation.service';
import { environment } from 'src/environments/environment';

//declare function ire(string,{}): any;
@Component({
  selector: 'app-data-sensitive-plan',
  templateUrl: './data-sensitive-plan.component.html',
  styleUrls: ['./data-sensitive-plan.component.scss']
})
export class DataSensitivePlanComponent implements OnInit {

  text = 'Private.';
  displayText = '';
  showCursor = true;
  showLock = false;
  environment = environment;

  private timer: any;
  private isBrowser: boolean;

  @ViewChildren('contentHeading')
  contentHeadings!: QueryList<ElementRef<HTMLElement>>;

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    public loadScript: LoadScriptService,
    public navigationService: NavigationService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.titleService.setTitle("Grammar Checker for Confidential Documents | Trinka AI");
    this.metaTagService.updateTag({ name: 'description', content: "Trinka's secure grammar checker keeps confidential data safe with no data storage or AI training. Private AI writing assistant for individuals & enterprises." });
    this.metaTagService.updateTag({ property: 'og:title', content: "Grammar Checker for Confidential Documents | Trinka AI" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Trinka's secure grammar checker keeps confidential data safe with no data storage or AI training. Private AI writing assistant for individuals & enterprises." });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/enterprise/confidential-data-plan-for-grammar-checker' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: "Grammar Checker for Confidential Documents | Trinka AI" });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Trinka's secure grammar checker keeps confidential data safe with no data storage or AI training. Private AI writing assistant for individuals & enterprises." });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/enterprise/confidential-data-plan-for-grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise/confidential-data-plan-for-grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise/confidential-data-plan-for-grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/enterprise/confidential-data-plan-for-grammar-checker' });
    //this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/enterprise/sensitive-data-plan' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/enterprise/sensitive-data-plan' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/enterprise/sensitive-data-plan' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/enterprise/confidential-data-plan-for-grammar-checker' });
    //this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/enterprise/sensitive-data-plan' });
    
    if (isPlatformServer(this.platformId)) {
      const script = this._renderer2.createElement('script');
      script.type = 'application/ld+json';
      script.text = `{"@context":"https://schema.org/","@type":"Product","name":"Grammar Checker for Confidential Documents | Trinka AI","image":"https://www.trinka.ai/assets/images/data-security/data-handling.svg","description":"Trinka's secure grammar checker keeps confidential data safe with no data storage or AI training. Private AI writing assistant for individuals & enterprises.","brand":{"@type":"Brand","name":"Trinka AI"},"aggregateRating":{"@type":"AggregateRating","ratingValue":"5","bestRating":"5","worstRating":"3.5","ratingCount":"1578"}}`
      this._renderer2.appendChild(this._document.head, script);

      const script1 = this._renderer2.createElement('script');
      script1.type = 'application/ld+json';
      script1.text = `{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Trinka: AI Writing and Grammar Checker Tool","item":"https://www.trinka.ai/"},{"@type":"ListItem","position":2,"name":"Trinka Enterprise - Writing Assistant & Grammar Checker For Your Teams","item":"https://www.trinka.ai/enterprise"},{"@type":"ListItem","position":3,"name":"Grammar Checker for Confidential Documents | Trinka AI","item":"https://www.trinka.ai/enterprise/confidential-data-plan-for-grammar-checker"}]}`
      this._renderer2.appendChild(this._document.head, script1);

      const script2 = this._renderer2.createElement('script');
      script2.type = 'application/ld+json';
      script2.text = `{"@context":"https://schema.org","@type":"SoftwareApplication","name":"Grammar Checker for Confidential Documents | Trinka AI","url":"https://www.trinka.ai/enterprise/confidential-data-plan-for-grammar-checker","description":"Trinka's secure grammar checker keeps confidential data safe with no data storage or AI training. Private AI writing assistant for individuals & enterprises.","applicationCategory":"WebApplication","operatingSystem":"Web"}`
      this._renderer2.appendChild(this._document.head, script2);

      const script3 = this._renderer2.createElement('script');
      script3.type = 'application/ld+json';
      script3.text = `{"@context":"https://schema.org","@type":"Organization","name":"Grammar Checker for Confidential Documents | Trinka AI","url":"https://www.trinka.ai/enterprise/confidential-data-plan-for-grammar-checker","@id":"https://www.trinka.ai/enterprise/confidential-data-plan-for-grammar-checker#organization","description":"Trinka's secure grammar checker keeps confidential data safe with no data storage or AI training. Private AI writing assistant for individuals & enterprises.","logo":{"@type":"ImageObject","url":"https://www.trinka.ai/assets/images/trinka_logo.svg"},"email":"support@trinka.ai","sameAs":["https://www.facebook.com/thetrinkaai/","https://www.instagram.com/thetrinkaai/","https://x.com/thetrinkaai","https://www.linkedin.com/company/thetrinkaai","https://www.youtube.com/channel/UC1PNKZCxdUArpPVr5YFaYcA"],"address":{"@type":"PostalAddress","streetAddress":"8A, 8th Floor, Techniplex II, SV Road,","addressLocality":"Goregaon West, Mumbai,","addressRegion":"Maharashtra ","postalCode":"400062","addressCountry":"India"}}`
      this._renderer2.appendChild(this._document.head, script3);

      const script4 = this._renderer2.createElement('script');
      script4.type = 'application/ld+json';
      script4.text = `{"@context":"https://schema.org","@type":"WebPage","@id":"https://www.trinka.ai/enterprise/confidential-data-plan-for-grammar-checker","name":"Grammar Checker for Confidential Documents | Trinka AI","url":"https://www.trinka.ai/enterprise/confidential-data-plan-for-grammar-checker","description":"Trinka's secure grammar checker keeps confidential data safe with no data storage or AI training. Private AI writing assistant for individuals & enterprises.","inLanguage":"en","isPartOf":{"@type":"WebSite","@id":"https://www.trinka.ai/"}}`
      this._renderer2.appendChild(this._document.head, script4);

      const script5 = this._renderer2.createElement('script');
      script5.type = 'application/ld+json';
      script5.text = `{"@context":"https://schema.org","@type":"VideoObject","name":"Confidential Data Plan | Trinka","description":"Introducing Trinka's Confidential Data Plan: the secure grammar checker built for confidential documents. Experience the power of grammar checking without compromising your data. No data retention. No persistent storage on our servers. Automatic deletion post-processing. Unmatched confidentiality for your content. No AI training on your data.Protect your trade secrets and intellectual property. With Trinka's Confidential Data Plan, your sensitive data remains your secret!","thumbnailUrl":"https://i.ytimg.com/vi/Vrca2hiUp2k/sddefault.jpg?sqp=-oaymwEmCIAFEOAD8quKqQMa8AEB-AH-CYAC0AWKAgwIABABGGUgWyhlMA8=&rs=AOn4CLCtynohRBqYFFNyfdoBusLUcvsQmA","uploadDate":"2025-09-09","duration":"PT0M45S","contentUrl":"https://www.trinka.ai/enterprise/confidential-data-plan-for-grammar-checker","embedUrl":"https://www.youtube.com/watch?v=Vrca2hiUp2k"}`
      this._renderer2.appendChild(this._document.head, script5);
    }
    if (this.isBrowser) {
      this.runLoop();
    } else {
      // SSR: show final state immediately
      this.displayText = '';
      this.showCursor = false;
      this.showLock = true;
    }
    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
  }
  
  ngOnDestroy() {
    clearTimeout(this.timer);
  }

  runLoop() {
    this.displayText = '';
    this.showCursor = true;
    this.showLock = false;

    this.typeText();
  }

  typeText() {
    let index = 0;

    const typeInterval = setInterval(() => {
      this.displayText += this.text[index];
      index++;

      if (index === this.text.length) {
        clearInterval(typeInterval);
        this.timer = setTimeout(() => this.eraseText(), 800);
      }
    }, 120);
  }

  eraseText() {
    const eraseInterval = setInterval(() => {
      this.displayText = this.displayText.slice(0, -1);

      if (this.displayText.length === 0) {
        clearInterval(eraseInterval);
        this.showCursor = false;
        this.showLock = true;

        this.timer = setTimeout(() => this.runLoop(), 1500);
      }
    }, 80);
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  @ViewChild('targetElement') targetElement!: ElementRef;

  scrollToTarget() {
    if (this.targetElement) {
      this.targetElement.nativeElement.scrollIntoView({ behavior: 'smooth' });
    }
  }

  trackByFn(index: number, item: any): string | number {
    return item.id || index;
  }

  stopAllVideos() {
    const iframes = Array.from(document.querySelectorAll('iframe.youtubeVideoForTryDemo'));
    iframes.forEach((iframe) => {
        const htmlIframe = iframe as HTMLIFrameElement;
        htmlIframe.src = htmlIframe.src;
    });
  }
  @ViewChild('bgVideo') bgVideo!: ElementRef<HTMLVideoElement>;
  @ViewChild('progressList') progressList!: ElementRef;
  autoplayTime = 5000;
  progressHeight = '0px';
  @ViewChild('glideRef') glideRef!: ElementRef;
  glide: any;
  activeIndex = 0;
  @ViewChildren('industryCard')
  industryCards!: QueryList<ElementRef<HTMLElement>>;

  ngAfterViewInit() {
    this.glide = new Glide(this.glideRef.nativeElement, {
      type: 'slider',
      perView: 1,
      animationDuration: 400,
      autoplay: 6000,
      hoverpause: true
    });
  
    this.glide.mount();
  
    // initial state
    this.activeIndex = 0;
  
    this.glide.on('run.after', () => {
      this.activeIndex = this.glide.index;
    
      setTimeout(() => {
        this.industryCards
          .toArray()[this.activeIndex]
          ?.nativeElement.focus({ preventScroll: true });
      }, 0);
    });

    const video = this.bgVideo.nativeElement;
    video.muted = true;
    video.play().catch(() => {});
  }

  goToSlide(index: number) {
    this.activeIndex = index;
    this.glide.go('=' + index);
  
    setTimeout(() => {
      this.industryCards.toArray()[index]?.nativeElement.focus();
    }, 450);
  }

  industries = [
    {
      image: 'assets/images/enterprise/confidential-data/icons/healthcare.svg',
      bgimage: 'assets/images/enterprise/confidential-data/healthcare.webp',
      title: 'Healthcare & Pharmaceuticals',
      content: 'Working with clinical trial data, patient case studies, medical reports, and drug development documents where privacy and regulatory boundaries matter from draft to final.'
    },
    {
      image: 'assets/images/enterprise/confidential-data/icons/academic.svg',
      bgimage: 'assets/images/enterprise/confidential-data/academic.webp',
      title: 'Academic Research & Institutions',
      content: 'Drafting grant proposals, unpublished manuscripts, IRB applications, and thesis work before submission, where early exposure can compromise originality and ownership.'
    },
    {
      image: 'assets/images/enterprise/confidential-data/icons/patent.svg',
      bgimage: 'assets/images/enterprise/confidential-data/patent.webp',
      title: 'Patents & Research Development',
      content: 'Preparing pre-filing patent drafts, invention disclosures, R&D documentation, and technical specifications that define future intellectual property.'
    },
    {
      image: 'assets/images/enterprise/confidential-data/icons/legal.svg',
      bgimage: 'assets/images/enterprise/confidential-data/legal.webp',
      title: 'Legal & Compliance',
      content: 'Handling attorney-client communications, contracts, litigation materials, and sensitive negotiations that must remain confidential at every stage.'
    },
    {
      image: 'assets/images/enterprise/confidential-data/icons/finance.svg',
      bgimage: 'assets/images/enterprise/confidential-data/finance.webp',
      title: 'Financial Services & Consulting',
      content: 'Reviewing investment analyses, due diligence reports, client documents, and strategic recommendations that carry market and reputational risk.'
    },
    {
      image: 'assets/images/enterprise/confidential-data/icons/cyber-security.svg',
      bgimage: 'assets/images/enterprise/confidential-data/cyber-security.webp',
      title: 'Cybersecurity, Defense & Government',
      content: 'Working with threat intelligence, security assessments, restricted communications, and regulated documentation where data privacy is non-negotiable.'
    },
    {
      image: 'assets/images/enterprise/confidential-data/icons/creative.svg',
      bgimage: 'assets/images/enterprise/confidential-data/creative.webp',
      title: 'Creative, Media & Competitive Intelligence',
      content: 'Editing unreleased scripts, investigative content, market research, and strategic insights that derive value from staying non-public.'
    },
    {
      image: 'assets/images/enterprise/confidential-data/icons/energy-infra.svg',
      bgimage: 'assets/images/enterprise/confidential-data/energy-infra.webp',
      title: 'Energy & Infrastructure',
      content: 'Drafting operational plans, exploration data, infrastructure assessments, and strategic documents tied to long-term planning and critical systems.'
    },
    {
      image: 'assets/images/enterprise/confidential-data/icons/others.svg',
      bgimage: 'assets/images/enterprise/confidential-data/others.webp',
      title: 'Anyone working with sensitive content',
      content: 'No matter your industry, if you handle sensitive or non-public content, the Confidential Data Plan lets you use AI with confidence.'
    }
  ].map(item => ({
    ...item,
    words: item.content.split(' ')
  }));


  getWordDelay(wordIndex: number, totalWords: number) {
    const totalTime = this.autoplayTime / 1000; // convert to seconds
    const step = totalTime / totalWords;
    return (wordIndex * step) + 's';
  }

  buildPlanCheckoutUrl(
    planType: string,
    opts: {
      coupon?: string;
      utm_source?: string;
      utm_medium?: string;
      utm_campaign?: string;
      utm_id?: string;
    } = {}
  ) {
    const {
      coupon,
      utm_source,
      utm_medium,
      utm_campaign,
      utm_id
    } = opts;
  
    const payload = {
      frmktg: true,
      go_to_payments: true,
      plan_type: planType,
      planType: planType,
      plan_name: 'basic'
    };
  
    const encoded = btoa(
      encodeURIComponent(JSON.stringify(payload))
    ).replace(/=/g, '');
  
    const params = new URLSearchParams();
  
    if (coupon) params.set('cp', coupon);
    if (utm_source) params.set('utm_source', utm_source);
    if (utm_medium) params.set('utm_medium', utm_medium);
    if (utm_campaign) params.set('utm_campaign', utm_campaign);
    if (utm_id) params.set('utm_id', utm_id);
  
    const query = params.toString();
  
    return `${environment.paymentsUrl}/user/${encoded}${query ? `?${query}` : ''}`;
  }

}
